import React, { Component } from 'react';
import axios from 'axios';
import ExternalStudentPersonalInformationForm from './ExternalStudentPersonalInformationForm';
import ExternalStudentSendingInstitutionForm from './ExternalStudentSendingInstitutionForm';
import ExternalStudentExchangeInformationForm from './ExternalStudentExchangeInformationForm';
import { Loader, Segment } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import ExternalStudentCompletionDetailsForm from './ExternalStudentCompletionDetailsForm';
import { externalStudentToBodyMapper, validateExternalStudent } from './ExternalStudentInputForm';

class ExternalStudentEditWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            student: props.student,
            errors: {},
            originalStudent: props.student,
            personalInformation: props.personalInformation,
            sendingInstitution: props.sendingInstitution,
            exchangeInformation: props.exchangeInformation,
            completionDetails: props.completionDetails,
        };
    }

    handleChange = (updatedFields) => {
        this.setState((prevState) => ({
            student: {
                ...prevState.student,
                ...updatedFields
            }
        }));
    };

    handleSubmit = (student) => {
        const body = externalStudentToBodyMapper(student);

        const errors = validateExternalStudent(student);
        this.setState({ errors });

        if (Object.values(errors)
            .some((err) => err)) {
            toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
            return;
        }

        this.setState({ saving: true });

        axios.put(`/external-student/`, body)
            .then((res) => {
                this.setState({ saving: false });
                this.props.onEdit(student);
                this.props.onCancel();
                toast(<FormattedMessage id="externalStudent.toast.editSuccess"/>);
            })
            .catch((err) => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.editError"/>);
            });
    };

    render() {
        const {
            saving,
            student,
            errors,
            personalInformation,
            sendingInstitution,
            exchangeInformation,
            completionDetails,
        } = this.state;

        if (saving) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        if (personalInformation) {
            return <ExternalStudentPersonalInformationForm student={student} errors={errors} edit
                                                           onCancel={this.props.onCancel}
                                                           onSave={this.handleSubmit}
                                                           onChangeStudent={this.handleChange}
            />;
        }

        if (sendingInstitution) {
            return <ExternalStudentSendingInstitutionForm student={student} errors={errors} edit
                                                          onCancel={this.props.onCancel}
                                                          onSave={this.handleSubmit}
                                                          onChangeStudent={this.handleChange}
            />;
        }

        if (exchangeInformation) {
            return <ExternalStudentExchangeInformationForm student={student} errors={errors} edit
                                                           onCancel={this.props.onCancel}
                                                           onSave={this.handleSubmit}
                                                           onChangeStudent={this.handleChange}
            />;
        }

        if (completionDetails) {
            return <ExternalStudentCompletionDetailsForm
                student={student}
                errors={errors}
                edit
                onCancel={this.props.onCancel}
                onSave={this.handleSubmit}
                onChangeStudent={this.handleChange}
            />;
        }

        return <Segment></Segment>;
    }
}

export default ExternalStudentEditWrapper;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentForms/ExternalStudentEditWrapper.js